module.exports = "/_next/static/images/operations2-e7ae9e3cf240e959aac380fe11ed392b.svg";